import { createAsyncLocalStorage } from "./async-local-storage";
export const staticGenerationAsyncStorage = createAsyncLocalStorage();

//# sourceMappingURL=static-generation-async-storage.external.js.map